import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { periodRange, shiftPeriod } from './payroll';
import { isBlockingFlag } from './rateEngine';

// Fixed flags; weight/dims flag labels come from the rate card (`piece.flagLabels`).
export const FLAG_LABELS = {
  UNMAPPED_FSA: 'FSA not on rate card',
  ZONE_NOT_SERVICED: 'Zone N/A',
  NO_CUSTOMER_CARD: 'No customer rate card',
};

const STATUS_STYLES = {
  parsed: 'bg-amber-500/15 text-amber-500 border-amber-500/30',
  draft: 'bg-amber-500/15 text-amber-500 border-amber-500/30',
  approved: 'bg-sky-500/15 text-sky-500 border-sky-500/30',
  posted: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/30',
  processed: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/30',
  issued: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/30',
  superseded: 'bg-muted text-muted-foreground border-border',
  error: 'bg-red-500/15 text-red-500 border-red-500/30',
};

export const StatusBadge = ({ status, label, className = '' }) => (
  <Badge variant="outline" className={`${STATUS_STYLES[status] || ''} ${className}`}>
    {label || status}
  </Badge>
);

export const FlagBadge = ({ flag, label }) => (
  <Badge
    variant="outline"
    className={`text-[10px] ${isBlockingFlag(flag) ? 'border-red-500/40 text-red-500' : 'border-amber-500/40 text-amber-500'}`}
  >
    {label || FLAG_LABELS[flag] || flag}
  </Badge>
);

export const Kpi = ({ label, value, sub, icon, accent = 'text-foreground' }) => (
  <Card className="bg-card border-border">
    <CardContent className="p-4">
      <div className="flex items-start justify-between">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">{label}</p>
        <i className={`fas ${icon} text-muted-foreground`}></i>
      </div>
      <p className={`text-2xl font-bold mt-2 ${accent}`}>{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </CardContent>
  </Card>
);

/** Steps through fixed-length periods (pay period or invoice week). */
export const PeriodPicker = ({ start, cfg, onChange, idPrefix, title }) => (
  <div className="flex items-center gap-2">
    {title && <span className="text-xs uppercase tracking-wide text-muted-foreground">{title}</span>}
    <Button id={`${idPrefix}-period-prev`} size="sm" variant="outline" onClick={() => onChange(shiftPeriod(start, -1, cfg))}>
      <i className="fas fa-chevron-left"></i>
    </Button>
    <span className="text-sm font-medium min-w-[210px] text-center">{periodRange(start, cfg).label}</span>
    <Button id={`${idPrefix}-period-next`} size="sm" variant="outline" onClick={() => onChange(shiftPeriod(start, 1, cfg))}>
      <i className="fas fa-chevron-right"></i>
    </Button>
  </div>
);

export const EmptyState = ({ icon, title, children }) => (
  <Card className="bg-card border-border border-dashed">
    <CardContent className="p-12 text-center">
      <i className={`fas ${icon} text-4xl text-muted-foreground mb-4`}></i>
      <h3 className="text-lg font-semibold">{title}</h3>
      {children && <p className="text-sm text-muted-foreground mt-1">{children}</p>}
    </CardContent>
  </Card>
);
